import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './sec7.css';
import './sec6.css';
import BookingHero from '../common/headsec';
import { supabase } from '../../supabaseClient';

import quoteIc from '../../asserts/qoution.png';
import starsIc from '../../asserts/stars.png';
import midImg from '../../asserts/sec7img.png';
import starsRating from '../../asserts/stars.png';

import avatar1 from '../../asserts/av.png';
import avatar2 from '../../asserts/av2.png';

const Sec7 = () => {
    const { t } = useTranslation();
    const [modalOpen, setModalOpen] = useState(false);
    const [events, setEvents] = useState([]);
    const [form, setForm] = useState({
        user_name: '',
        event_id: '',
        comment_en: ''
    });
    const [rating, setRating] = useState(5);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        const getEvents = async () => {
            const { data } = await supabase
                .from('events')
                .select('id, title_en');

            setEvents(data || []);
        };

        getEvents();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (!form.user_name || !form.event_id || !form.comment_en) {
            setError('All fields are required');
            return;
        }

        const { error } = await supabase
            .from('eventfeedback')
            .insert([
                {
                    user_name: form.user_name,
                    event_id: Number(form.event_id),
                    comment_en: form.comment_en,
                    status: 'Draft'
                }
            ]);

        if (error) {
            setError('Something went wrong');
        } else {
            setSuccess('Successfully sent');
            setForm({
                user_name: '',
                event_id: '',
                comment_en: ''
            });
            setRating(5);
        }
    };

    return (
        <>
            {modalOpen && (
                <div className="rv-overlay" onClick={(e) => { if (e.target === e.currentTarget) setModalOpen(false); }}>
                    <div className="rv-modal">
                        <div className="rv-modal-header">
                            <h2 className="rv-modal-title">Add New Testimonial</h2>
                            <svg className="rv-modal-close" onClick={() => setModalOpen(false)} viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className="rv-modal-body">
                            <form className="rv-form" onSubmit={handleSubmit}>
                                <div className="rv-form-row">
                                    <div className="rv-form-field">
                                        <label className="rv-form-label">Customer Name</label>
                                        <input
                                            type="text"
                                            className="rv-form-input"
                                            value={form.user_name}
                                            onChange={(e) => setForm({ ...form, user_name: e.target.value })}
                                        />
                                    </div>
                                    <div className="rv-form-field">
                                        <label className="rv-form-label">Event</label>
                                        <select
                                            className="rv-form-input rv-form-select"
                                            value={form.event_id}
                                            onChange={(e) => setForm({ ...form, event_id: e.target.value })}
                                        >
                                            <option value="">Select Event</option>
                                            {events.map(ev => (
                                                <option key={ev.id} value={ev.id}>{ev.title_en}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="rv-form-field">
                                    <label className="rv-form-label">Review Text</label>
                                    <textarea
                                        className="rv-form-textarea"
                                        value={form.comment_en}
                                        onChange={(e) => setForm({ ...form, comment_en: e.target.value })}
                                    ></textarea>
                                </div>
                                <div className="rv-form-field">
                                    <label className="rv-form-label">Star Rating</label>
                                    <div className="rv-stars">
                                        {[1,2,3,4,5].map(s => (
                                            <svg
                                                key={s}
                                                onClick={() => setRating(s)}
                                                className={s <= rating ? '' : 'rv-star--empty'}
                                                viewBox="0 0 20 20"
                                            >
                                                <path d="M10 1l2.39 5.26L18 7.27l-4 3.9.94 5.5L10 14l-4.94 2.67.94-5.5-4-3.9 5.61-.01z"/>
                                            </svg>
                                        ))}
                                    </div>
                                </div>
                                {error && <p className='err'>{error}</p>}
                                {success && <p className='suc'>{success}</p>}
                                <div className="rv-form-footer">
                                    <button type="button" className="rv-cancel-btn" onClick={() => setModalOpen(false)}>Cancel</button>
                                    <button type="submit" className="rv-save-btn">
                                        <svg viewBox="0 0 20 20" fill="none">
                                            <path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        Save Testimonial
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            <section className='sec7'>
                <div className='sec7-container'>

                    <BookingHero
                        t1={t('sec7_hero_tag')}
                        t2={t('sec7_hero_t1')}
                        t3={t('sec7_hero_t2')}
                        text={t('sec7_hero_text')}
                    />

                    <div className='sec7-content'>

                        <div className='sec7-card'>
                            <div className='sec7-card-top'>
                                <img className='sec7-stars' src={starsIc} alt='stars' />
                                <img className='sec7-quote' src={quoteIc} alt='quote' />
                            </div>
                            <p className='sec7-card-text'>{t('sec7_quote1')}</p>
                            <div className='sec7-card-author'>
                                <img className='sec7-avatar' src={avatar1} alt='Sarah Johnson' />
                                <div>
                                    <p className='sec7-author-name'>Sarah Johnson</p>
                                    <p className='sec7-author-role'>Music Enthusiast</p>
                                </div>
                            </div>
                        </div>

                        <div className='sec7-mid'>
                            <img className='sec7-mid-img' src={midImg} alt='celebration' />
                        </div>

                        <div className='sec7-card'>
                            <div className='sec7-card-top'>
                                <img className='sec7-stars' src={starsIc} alt='stars' />
                                <img className='sec7-quote' src={quoteIc} alt='quote' />
                            </div>
                            <p className='sec7-card-text'>{t('sec7_quote2')}</p>
                            <div className='sec7-card-author'>
                                <img className='sec7-avatar' src={avatar2} alt='Emily Rodriguez' />
                                <div>
                                    <p className='sec7-author-name'>Emily Rodriguez</p>
                                    <p className='sec7-author-role'>Theatre Lover</p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className='sec7-rating'>
                        <img className='sec7-rating-stars' src={starsRating} alt='rating stars' />
                        <div className='sec7-rating-info'>
                            <span className='sec7-rating-score'>4.9/5</span>
                            <span className='sec7-rating-count'>{t('sec7_reviews')}</span>
                        </div>
                        <button className='sec6btn' onClick={() => setModalOpen(true)}>
                            {t('sec7_btn')}
                        </button>
                    </div>

                </div>
            </section>
        </>
    );
};

export default Sec7;